/**
 * Dependency-free condition constants for the ToggleTextButton "condition"
 * input. Kept in a LEAF module (no imports) so consumers that read them at
 * module-load — notably the Builder block's `enum: Object.values(conditionOptionsMap)`
 * in `cta/toggleTextButton.tsx` — never pull the
 * `utils → conditionComponentsMap → ActiveGoalButtonText → useLearningCenter`
 * import cycle that left `conditionOptionsMap` `undefined` mid-evaluation
 * (a module-load `TypeError: Cannot convert undefined or null to object`).
 *
 * `conditionComponentsMap` (which maps these keys to React components) stays in
 * `./utils` because it must import the component; only the plain constants live
 * here.
 */
export const conditionOptionsMap = {
  ACTIVE_GOAL: "User has an active goal",
};

export const editorStateMap = {
  CONDITION_MET: "Condition Met",
  CONDITION_NOT_MET: "Condition Not Met",
};
